import { PaymentModel } from './payment.model';

export class SessionCacheModel {
  public data: any;
  public iat: number;

  constructor() {
    this.data = null;
    this.iat = null;
  }
}
